import { uploadFileToS3 } from '@/utils/s3Utils';
import { delay } from '@/utils/timingUtils';

(function () {
    'use strict';
    'ngInject';
    angular.module('app.ctrls').controller('LibrariesCtrl', librariesCtrl);

    function librariesCtrl(
        $scope,
        LibrariesAPIService,
        LibrariesUtilService,
        ProductAPIService,
        $location,
        $timeout,
        $mdDialog,
        blockUI,
        ConfigService
    ) {
        $scope.colorModeStrings = ['RGB', 'CMYK'];
        $scope.filteredLibraries = [];
        $scope.currentPage = 1;
        $scope.numPerPage = 15;
        $scope.maxSize = 5;
        $scope.begin = 0;
        $scope.librariesCount = 0;
        $scope.searchString = '';
        $scope.libraryType = ConfigService.getLastSelectedLibrariesTab() || 'color';
        $scope.currentNavItem = $scope.libraryType;

        // Get library picker settings
        $scope.viewerSettings = LibrariesUtilService.getCurrentPickerSettings();

        $scope.$watch('currentPage + numPerPage', function () {
            $scope.begin = ($scope.currentPage - 1) * $scope.numPerPage;
            $scope.getLibraries();
        });

        $scope.addLibrary = function () {
            $mdDialog
                .show({
                    locals: {
                        libraryTypeString: $scope.libraryType
                    },
                    controller: 'NewLibraryCtrl',
                    template: require('../../../../views/pages/libraries/dialogs/new-library/newLibraryDialog.html'),
                    parent: angular.element(document.body),
                    clickOutsideToClose: false
                })
                .then(
                    function (result) {
                        console.log('Creating library with name: ' + result.name);
                        blockUI.start();
                        LibrariesAPIService.createLibrary(result.name, result.colorMode, $scope.libraryType)
                            .then(function (newLibrary) {
                                console.log('Library created!');
                                blockUI.stop();
                                $scope.edit(newLibrary);
                            })
                            .catch(function (error) {
                                window.rumReportError(error);
                                blockUI.stop();
                            });
                    },
                    function () {
                        // Dialog canceled
                    }
                );
        };

        $scope.bulkUpload = async function (event) {
            const filesInput = document.querySelector('#bulkLibrary');
            const files = event.target.files;
            let currentProgress = 0;

            if (files && files[0]) {
                try {
                    blockUI.start('Uploading zip');
                    const zipFile = files[0];

                    if (zipFile.size > 2 ** 30) {
                        blockUI.stop();
                        $mdDialog.show(
                            $mdDialog
                                .alert()
                                .parent(document.body)
                                .clickOutsideToClose(true)
                                .title('An error has occurred')
                                .htmlContent(
                                    `
                                    you have passed the maximum size allowed.< /br>
                                    The maximum size is 1GB.
                                `
                                )
                                .ok('OK')
                        );
                        filesInput.value = '';
                        return;
                    }

                    const urlResponse = await ProductAPIService.getProductImportSignedUrl();

                    await uploadFileToS3(urlResponse.SignedUrl, urlResponse.Mime, zipFile, null, (progress) => {
                        blockUI.message(`Uploading zip ${parseInt(progress)}%`);
                        $timeout(() => $scope.$apply());
                    });

                    const newLibrary = await LibrariesAPIService.uploadLibrary(files[0].name, urlResponse.Name);

                    while (currentProgress < 100) {
                        const uploadTasksProgress = await LibrariesAPIService.uploadLibraryProgress(
                            newLibrary.progressIdentifier
                        );

                        await delay(2000);

                        currentProgress = uploadTasksProgress.progress;

                        blockUI.message(`Creating library ${parseInt(currentProgress)}%`);

                        if (uploadTasksProgress.error) {
                            blockUI.stop();
                            $mdDialog.show(
                                $mdDialog
                                    .alert()
                                    .parent(document.body)
                                    .clickOutsideToClose(true)
                                    .title('An error has occurred')
                                    .htmlContent(`${uploadTasksProgress.errorMessage.replace('.', '.<br />')}.`)
                                    .ok('OK')
                            );
                            return;
                        }

                        if (currentProgress === 100) {
                            blockUI.stop();
                            $scope.begin = $scope.librariesCount;

                            $scope.getLibraries();
                            $mdDialog.show(
                                $mdDialog
                                    .alert()
                                    .parent(document.body)
                                    .clickOutsideToClose(true)
                                    .title('Creating library')
                                    .htmlContent(`The libraries have been created correctly`)
                                    .ok('OK')
                            );
                            return;
                        }
                    }
                } catch (error) {
                    blockUI.stop();

                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(true)
                            .title('An error has occurred')
                            .htmlContent(`Something wrong happened while creating the libraries!`)
                            .ok('OK')
                    );
                } finally {
                    filesInput.value = '';
                    blockUI.stop();
                }
            }
        };

        $scope.getLibraries = function () {
            blockUI.start('Loading libraries');
            // Remove spaces
            $scope.searchString = $scope.searchString.trim();
            LibrariesAPIService.getLibraries($scope.searchString, $scope.begin, $scope.numPerPage, $scope.libraryType)
                .then(function (data) {
                    $scope.filteredLibraries = data;
                    LibrariesAPIService.getLibrariesCount($scope.searchString, $scope.libraryType)
                        .then(function (count) {
                            $scope.librariesCount = count;
                            blockUI.stop();
                        })
                        .catch(function (error) {
                            window.rumReportError(error);
                            blockUI.stop();
                        });
                })
                .catch(function (error) {
                    window.rumReportError(error);
                    blockUI.stop();
                });
        };

        $scope.getCategories = function () {
            blockUI.start('Loading categories');
            // Remove spaces
            $scope.searchString = $scope.searchString.trim();
            LibrariesAPIService.getCategories($scope.searchString, $scope.begin, $scope.numPerPage, $scope.libraryType)
                .then(function (data) {
                    $scope.filteredLibraries = data;
                    LibrariesAPIService.getLibrariesCount($scope.searchString, $scope.libraryType)
                        .then(function (count) {
                            $scope.librariesCount = count;
                            blockUI.stop();
                        })
                        .catch(function (error) {
                            window.rumReportError(error);
                            blockUI.stop();
                        });
                })
                .catch(function (error) {
                    window.rumReportError(error);
                    blockUI.stop();
                });
        };

        $scope.delete = function (library, index) {
            var confirm = $mdDialog
                .confirm()
                .title('Library Deletion')
                .htmlContent(
                    'Are you sure you want to delete "<b>' +
                        library.Name +
                        '</b>" with id "<b>' +
                        library.LibraryId +
                        '</b>"?'
                )
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(
                async function () {
                    // Delete the library
                    blockUI.start('Deleting library');
                    try {
                        await LibrariesAPIService.deleteLibrary(library.LibraryId);
                        $scope.filteredLibraries.splice(index, 1);
                        blockUI.stop();
                        $scope.getLibraries();
                    } catch (error) {
                        // There are products using the library!
                        if (error.status === 409 && error.data.productIds) {
                            let html =
                                '<p>The library is being used in some Customily templates including:</p>' +
                                '<table width="100%" border="0" class="font-delete-table">' +
                                '<tbody>';
                            for (const productId of error.data.productIds) {
                                html += '<tr><td class="product-id"><b>' + productId + '<b/></td></tr>';
                            }
                            html += '</tbody></table>';
                            html +=
                                '<div class="mt10">Remove it from all Customily templates before deleting it.</div>';
                            $mdDialog.show(
                                $mdDialog
                                    .alert()
                                    .clickOutsideToClose(false)
                                    .multiple(true)
                                    .title('Library in use!')
                                    .htmlContent(html)
                                    .ok('OK')
                            );
                        } else {
                            window.rumReportError(e, (scope) => {
                                scope.addBreadcrumb({
                                    type: 'error',
                                    category: 'libraries',
                                    message: `Error deleting library ${library.LibraryId}`,
                                    level: 'error'
                                });
                            });
                        }
                    }
                },
                function () {
                    // Do nothing
                }
            );
        };

        $scope.edit = function (library) {
            $location.path('/editLibrary').search({
                id: library.LibraryId
            });
        };

        $scope.clone = function (library) {
            blockUI.start('Cloning library');
            LibrariesAPIService.cloneLibrary(library.LibraryId)
                .then(function (clonedLibrary) {
                    blockUI.stop();
                    $scope.getLibraries();
                })
                .catch(function (error) {
                    window.rumReportError(error);
                    blockUI.stop();
                    $mdDialog.show(
                        $mdDialog.alert().title('Library cloning!').textContent('Error cloning library').ok('OK')
                    );
                });
        };

        // Name edit
        $scope.editItem = function (library) {
            library.editing = true;
        };

        $scope.doneEditing = function (library) {
            library.editing = false;
            blockUI.start('Saving name');
            LibrariesAPIService.editLibrary(library.LibraryId, library.Name)
                .then(function (p) {
                    blockUI.stop();
                })
                .catch(function (error) {
                    window.rumReportError(error);
                    blockUI.stop();
                });
        };

        $scope.switchLibraryType = function (newType) {
            ConfigService.setLastSelectedLibrariesTab(newType);
            if (newType !== $scope.libraryType) {
                $scope.libraryType = newType;
                $scope.getLibraries();
            }
        };

        $scope.selectLibrary = function (library) {
            // If we get here, we are in dialog mode, close the dialog passing the selected library
            $mdDialog.hide(library);
        };

        // Set library type in viewer mode
        if ($scope.viewerSettings) {
            $scope.switchLibraryType($scope.viewerSettings.libraryType);
        }

        $scope.clearSearchString = function () {
            $scope.searchString = '';
        };

        $scope.goToNewLibraries = function () {
            localStorage.setItem('current-libraries-url', '');
            $location.path('/libraries');
        };
    }
})();
